import React, { useEffect, useState } from "react";
import AddAdminModal from "../Modals/AdminModal/AddAdmin";
import EditAdminModal from "../Modals/AdminModal/EditAdmin";
import Swal from "sweetalert2";
import axios from "axios";
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
const AdminPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [presidents, setPresidents] = useState([]);

  useEffect(() => {
    fetchAdmin();
  }, []);
  const fetchAdmin = async () => {
    try {
      const response = await axios.get("/admin/get_all");
      setPresidents(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);

  const handleAddPresident = (data) => {
    setPresidents([...presidents, { id: presidents.length + 1, ...data }]);
    fetchAdmin();
    toggleModal();
  };

  const handleEditPresident = (data) => {
    setPresidents(
      presidents.map((president) =>
        president.id === data.id ? { ...president, ...data } : president
      )
    );
    fetchAdmin();
    toggleEditModal();
  };

  const handleDeletePresident = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const response = axios.delete("/admin/delete", {
            params: {
              admin_id: id,
            },
          });
          if (response.data.success) {
            Swal.fire("Deleted!", "Your record has been deleted.", "success");
          }
          fetchAdmin();
        } catch (error) {
          console.error("Error fetching LOM Presidents:", error);
        }
      }
    });
  };

  const openEditModal = (record) => {
    setSelectedRecord(record);
    toggleEditModal();
  };

  const [userRole, setuserRole] = useState("");

  // Fetch profile data using member_id
  useEffect(() => {
    const profession_id = sessionStorage.getItem("profession_id");
    if (profession_id) {
      setuserRole(profession_id);
    }
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        <div className="mb-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Admin</h1>
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              onClick={toggleModal}
            >
              Add Admin
            </button>
          </div>

          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border px-4 py-2">JCI_Membership_id</th>
                <th className="border px-4 py-2">Admin_name</th>
                <th className="border px-4 py-2">Lom Name</th>
                <th className="border px-4 py-2">Contact Number</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {presidents.map((president) => (
                <tr key={president.id}>
                  <td className="border px-4 py-2">
                    {president.membership_id}
                  </td>
                  <td className="border px-4 py-2">{president.admin_name}</td>
                  <td className="border px-4 py-2">{president.lom_name}</td>
                  <td className="border px-4 py-2">
                    {president.contact_number}
                  </td>
                  <td className="border px-4 py-2 text-center flex">
                    <FaPen
                      className="text-amber-400 mt-5 text-xl cursor-pointer"
                      onClick={() => openEditModal(president)}
                    />

                    {userRole != "4" && (
                      <MdDeleteForever
                        className="ml-2 mt-5 mb-2 text-red-500 text-2xl cursor-pointer"
                        onClick={() =>
                          handleDeletePresident(president.membership_id)
                        }
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <AddAdminModal
        show={isModalOpen}
        onClose={toggleModal}
        onSubmit={handleAddPresident}
      />
      {isEditModalOpen && selectedRecord && (
        <EditAdminModal
          show={isEditModalOpen}
          onClose={toggleEditModal}
          onSubmit={handleEditPresident}
          data={selectedRecord}
        />
      )}
    </div>
  );
};

export default AdminPage;
